import 'jquery';

export default () => {

    $(document).on('mouseover', '.js-museum-box-item', function () {
        let $this = $(this);
        $this.addClass('hovered');
    });

    $(document).on('mouseleave', '.js-museum-box-item', function () {
        let $this = $(this);
        $this.removeClass('hovered');
    });

    $(document).on('touchstart', '.js-museum-box-item', function () {
        let $this = $(this);
        $this.addClass('hovered');
        $this.siblings('.js-museum-box-item').removeClass('hovered');
    });

};


// WEBPACK FOOTER //
// ./scripts/modules/hovers.js